export enum ButtonAction {
  Delete,
  Create,
  Change
}